/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/qaMenuBridge.ts
 * FILE_ID: JOBHUB-QA-MENU-BRIDGE-001
 * PURPOSE: The mounted Build table registers the one row-menu opener.
 */
type Point = { clientX: number; clientY: number }
type Opener = (itemId: string, point: Point) => void

let opener: Opener | null = null

export function setQaItemMenuOpener(next: Opener | null) {
  opener = next
}

export function hasQaItemMenuOpener() {
  return opener != null
}

export function openQaItemMenu(itemId: string, point: Point) {
  opener?.(itemId, point)
}
